import { IS_COMPARE_KEY } from "constants/isCompareKey"

export const removeIsCompareData = () => {
    localStorage.removeItem(IS_COMPARE_KEY);
}